import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Calendar, Card, Col, Collapse, Divider, Row } from 'antd'
import Button from 'components/Button/index'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const SectionWrapper = styled(Flex)`
  width: 100%;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;
  border-radius: 10px;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
  @media only screen and (max-device-width: 767px) {
    margin: 10px;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    margin: 30px 20px 20px 20px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1200px) {
    margin: 10px;
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  padding: 8px;
  color: ${COLORS.GREY_P_100};
`
export const ShowNum = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  padding-top: 10px;
  padding-right: 15px;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const AnchorText = styled.a`
  font-style: normal;
  font-weight: 500;
  padding-top: 10px;
  padding-right: 25px;
  font-size: 13px;
  line-height: 18px;
  color: ${COLORS.PRIMARY};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`

export const FilterCollapse = styled(Collapse)`
  background-color: #fafafb !important;

  .ant-collapse-header {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 10px !important;
    font-weight: 600;
    border-radius: 10px !important;
    border-radius: 5px;
    color: ${COLORS.GREY_T_60} !important;
    line-height: 1.5715;
    cursor: pointer;
    transition: all 0.3s, visibility 0s;
  }
`

export const VerticalDivider = styled(Divider)`
  height: 30px;
`

export const OutlineDiv = styled.div`
  height: 70px;
  padding-top: 10px;
`

export const RightDiv = styled.div`
  position: absolute;
  right: 0%;
  padding-right: 70px;
`

export const ContentCenterDiv = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
`
export const PaddedLeftFlex = styled(Flex)`
  padding-left: 75px;
`

export const Head1 = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  padding-left: 30px;
  padding-top: 30px;
  color: #010e30;
`
export const Head2 = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  padding-left: 30px;
  color: #808697;
`

export const Profile = styled.div`
  padding: 30px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #343e59;
`
export const Profile1 = styled.div`
  padding-left: 30px;
  padding-top: 5px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #494c4e;
`

export const PendingStyle = styled.div`
  padding-left: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #343e59;
`
export const RowContainer = styled(Row)`
  padding: 15px 10px;
`
export const ColContainer = styled(Col)`
  padding: 0px 10px;
  margin-top: ${props => (props.border ? '' : '20px')};
  
  border-left:  ${props => (props.border ? '1px solid #D9D9D9' : '')};

  
`
export const RightDiv1 = styled.div`
  border: 1px solid #D9D9D9;
  margin: 20px 15px 10px 10px;
  border-radius: 10px;
`
export const RightDiv2 = styled.div`
  background-color: #E1FBF1;
  border-radius: 10px;
  padding: 10px;
  margin:10px;
font-family: Plus Jakarta Sans;
font-weight: 400;
font-size: 12px;
line-height: 18px;
color: #000000;

  `
export const Spacingdiv = styled.div`
  padding: 10px;
`

export const MiniDateCal = styled(Calendar)`
  .ant-picker-content {
    border-collapse: inherit !important;
  }
  .ant-picker-calendar-mini .ant-picker-content th {
    padding: 10 !important;
  }
  td {
    border: 0px !important;
  }
  .ant-picker-cell {
    padding: 10px 0 !important;
  }
  .ant-picker-cell-in-view {
    color: #4d566e !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    height: 35px !important;
    width: 35px !important;
    border-radius: 50% !important;
    justify-content: center !important;
    padding-top: 5px !important;
  }
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 0px !important;
  }
`
export const LeftCol = styled(Col)`
  padding-left: 20px;
`
export const CenterCol = styled(Col)`
  text-align: center;
`

export const RightArrow = styled(RightOutlined)`
  cursor: pointer;
`

export const LeftArrow = styled(LeftOutlined)`
  cursor: pointer;
`

export const StyledFlex = styled.div`
  position: static;
  padding: 5px 48px 5px 20px;
  width: '100%';
  height: 140px;
  border-radius: 10px;
  border: 1px solid #e6e7ea;
  margin: 20px;
  box-shadow: 0px 2px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
`

export const Name = styled.div`
  font-weight: 600;
  font-size: 18px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  color: #1b1f22;
`

export const Address = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
`
export const BoldText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
`
export const StyledDiv = styled.div``
export const StyledSpan = styled.span``
export const StyledAnchor = styled.a``
export const NameAdd = styled(Flex)`
  gap: 3px;
  padding-left: 15px;
`
export const CardRow = styled(Flex)`
  gap: 5px;
  flex-wrap: wrap;
`

export const ToggleCard = styled(Card)`
  border: 1px solid #e3deff;
  background-color: #fbfaff;
  border-radius: 25px;
  margin: 10px;
  && .ant-card-body {
    padding: 15px !important;
  }
`
export const BlacklistDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 20px;
  border: 1px solid #e35e50;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 10px 20px;
  border-radius: 20px;
  color: #e35e50;

  span {
    font-family: Plus Jakarta Sans;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
  }
`
export const IconWrapper = styled.span`
  margin-left: 8px;
  font-size: 16px;
  color: red;
  cursor: pointer;
  .anticon svg {
    width: 20px;
    height: 20px;
    display: inline-block;
  }
`
